import { createContext, useContext } from 'react';

import type { MeterBarToolbarInternalProps } from '../types/meter-bar-toolbar.js';

export const MeterBarToolbarConfigContext = createContext<
  MeterBarToolbarInternalProps | undefined
>(undefined);

export const useMeterBarToolbarConfig = () => {
  return useContext(MeterBarToolbarConfigContext);
};

MeterBarToolbarConfigContext.displayName = 'MeterBarChartToolbarContext';
useMeterBarToolbarConfig.displayName = 'useMeterBarToolbarConfig';
